import { useQuery } from '@tanstack/react-query'
import {
  fixtureOneAccount,
  fromGetOneAccount,
  getOneAccount,
  type OneAccountView,
} from '@/api/map/oneAccount'
import { keys } from '@/api/hooks/shared/keys'
import type { PlStatementRowView } from '@/api/map/plStatement'

async function loadOneAccount(row: PlStatementRowView): Promise<OneAccountView> {
  try {
    const response = await getOneAccount(row.id)
    return fromGetOneAccount(response, row)
  } catch {
    return { ...fixtureOneAccount(row), bets: [], unavailable: 'empty' }
  }
}

/** Lab `Account/getOneAccount` — P&L row + bets for the Game Detail drawer. */
export function useOneAccount(row: PlStatementRowView | null) {
  return useQuery({
    queryKey: keys.oneAccount(row?.id ?? ''),
    queryFn: () => loadOneAccount(row!),
    enabled: Boolean(row?.id),
    retry: false,
  })
}
